// src/pages/driver/driverTimesheet/NotificationPill.jsx — small unread-count badge
import { formatNotificationCount } from "../../../utils/timesheetNotifications";

export default function NotificationPill({ count }) {
  const label = formatNotificationCount(count);
  if (!label) return null;

  return (
    <span className="inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-600 px-1.5 text-[11px] font-bold leading-none text-white shadow-sm">
      {label}
    </span>
  );
}
